import { MdRefresh } from "react-icons/md";
import Heading from "../UI/Heading";
import { BsPlusLg } from "react-icons/bs";
import SearchBar from "../UI/SearchBar";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { DataContext } from "../../context/data-context";

export default function CouponsPage() {
  const { coupons } = useContext(DataContext);
  const navigate = useNavigate();

  return (
    <div className="container grid">
      <Heading title="Coupons">
        <BsPlusLg onClick={() => navigate("/coupons/add")} className="icon" />
        <MdRefresh className="text-2xl icon" />
      </Heading>

      <SearchBar searchHandler={() => {}} clearSearch={() => {}} />

      <div className="list">
        {coupons.map((c, idx) => (
          <div key={idx} onClick={() => navigate("/coupons/info?id="+c.id)} className="grid grid-cols-5 text-sm pill text-stone-400">
            <p className="mx-auto text-stone-200">{c.code}</p>
            <p>
              {c.amount < 1 ? `${Number(c.amount) * 100}%` : `$${c.amount}`}
            </p>
            <p>{c.resuable ? "Resuable" : "Not Resuable"}</p>
            <p>{c.forId ? "Exclusive" : "Not Exclusive"}</p>
            <p>{c.usedBy ? `${c.usedBy.length} uses` : "Not Used"}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
